/**
 * @param value
 */
function parsePrice(value) {
  return (
    parseFloat(
      value
        .replace(/[^\d.,]/g, '') // delete everything except numbers, periods and commas
        .replace(/\s/g, '') // remove spaces (in some currencies)
        .replace(/\.(?=\d{3,})/g, '') // remove dots if they are 1 thousand separators
        .replace(',', '.') // replace the comma with a period
    ) * 100
  ); // convert to cents
}

// Formatting with a currency symbol
/**
 * @param cents
 * @param currencySymbol
 */
function formatMoney(cents, currencySymbol = '') {
  const euros = cents / 100;
  const formatted = euros.toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  // If there is a currency symbol, add it to the beginning of the line
  return currencySymbol ? `${formatted} ${currencySymbol}` : formatted;
}

// Main function of shipping calculation
/**
 *
 */
function cartShipping() {
  const shippingBlocks = document.querySelectorAll('.cart-shipping');

  shippingBlocks.forEach((shippingEl) => {
    const totalEl = document.querySelector('#main-cart-footer .totals__total-value') || document.querySelector('.totals__total-value');
    if (!shippingEl || !totalEl) return;

    const minTotal = parseFloat(shippingEl.dataset.minSpend); // in cents
    const total = parsePrice(totalEl.textContent); // also in cents
    if (Number.isNaN(minTotal) || Number.isNaN(total)) return;

    let progress = (total / minTotal) * 100;
    if (progress > 100) progress = 100;

    const defaultMsgEl = shippingEl.querySelector('.cart-shipping__message_default');
    const defaultMsgElText = shippingEl.querySelector('.cart-shipping__message_default .cart-shipping__message_default_text');
    const successMsgEl = shippingEl.querySelector('.cart-shipping__message_success');
    const progressEl = shippingEl.querySelector('.cart-shipping__progress-current');

    const currencySymbol = totalEl.textContent.match(/[^\d\s,.]+/g) ? totalEl.textContent.match(/[^\d\s,.]+/g)[0] : '';

    if (minTotal > total) {
      const amount = minTotal - total;
      const rawMsg = shippingEl.dataset.message;
      const message = rawMsg.replace('||amount||', formatMoney(amount, currencySymbol));
      if (defaultMsgElText) defaultMsgElText.innerHTML = message;
      if (successMsgEl) successMsgEl.classList.remove('active');
      if (defaultMsgEl) defaultMsgEl.classList.add('active');
      shippingEl.classList.remove('cart-shipping--complete');
    } else {
      if (defaultMsgEl) defaultMsgEl.classList.remove('active');
      if (successMsgEl) successMsgEl.classList.add('active');
      shippingEl.classList.add('cart-shipping--complete');
    }

    if (progressEl) {
      progressEl.style.width = `${progress}%`;
    }

    const deliveryBox = document.querySelector('[data-delivery-info-box]');
    if (deliveryBox) {
      const normalEl = deliveryBox.querySelector('.js-delivery-normal');
      const freeEl = deliveryBox.querySelector('.js-delivery-free');
      const priceEl = deliveryBox.querySelector('.js-delivery-price');
      if (minTotal > total) {
        if (priceEl) priceEl.textContent = deliveryBox.dataset.price;
        if (normalEl) normalEl.hidden = false;
        if (freeEl) freeEl.hidden = true;
      } else {
        if (normalEl) normalEl.hidden = true;
        if (freeEl) freeEl.hidden = false;
      }
    }
  });
}

window.cartShipping = cartShipping;

document.addEventListener('DOMContentLoaded', () => {
  cartShipping();
});
